export const updateMemberProfile = '/api/v1/member/profile';
export const getRecentViewedCourse = `/api/v1/member/profile/recent-course`;
export const saveRecentViewedCourse = `/api/v1/member/profile/recent-course`;
export const getInvoices = page => `/api/v1/member/invoices?page=${page}`;
export const getLatestInvoice = `/api/v1/member/invoices/latest`;
export const updateCreditCard = `/api/v1/member/profile/credit-card`;
export const changeMembership = '/api/v1/member/subscription/change';
export const scheduleCancelMembership = '/api/v1/member/subscription/schedule';
export const cancellationRequest = `/api/v1/member/subscription/cancellations`;